import React from 'react';
import './BusinessModel.less';
import { RadioButton, RadioGroup } from '@homeaway/react-form-components';
import { ButtonPrimary } from '@homeaway/react-buttons';
import backgroundImage from '../../images/cabin-blue-create-account-page.svg';
import handshakeIcon from '../../images/handshake-icon.js';
import onekeyIcon from '../../images/onekey-icon.js';
import creditCardIcon from '../../images/credit_card-icon.js';
import { MERCHANT_OF_RECORD } from '../../utils/constants';
import AlertBox from '../Alert/Alert';
import {SVGIcon} from '@homeaway/react-svg';

class BusinessModel extends React.Component {
    constructor(props) {
        super(props)
    }

    componentDidMount() {
        this.props.triggerEdapPageViewAction();
    }

    getBusinessModelChoices(translations, handleChoiceChange, businessModelChoice) {
        return (
            <div>
                <RadioGroup name="BusinessModelChoice" ariaLabel="Business model choices for supplier, or eg as merchant of record">
                    <RadioButton
                        className="business-model-toggle-button"
                        id="egMorChoice"
                        label={<div className="business-model-label">{translations['ipmob.business_model.eg_mor']}</div>}
                        value={MERCHANT_OF_RECORD.EG}
                        onChange={handleChoiceChange}
                        size="sm"
                        checked={businessModelChoice === MERCHANT_OF_RECORD.EG}
                        type={'radio'}
                    />
                    <span className="business-model-choice-description">{translations['ipmob.business_model.eg_mor.desc']}</span>
                    <div className="benefits-list">
                        <div className="benefits-list-item">
                            <div className="benefits-list-heading">
                                <SVGIcon className="benefit-icon" markup={handshakeIcon}/>
                                <h4 className="benefits-list-heading-text">{translations['ipmob.business_model.eg_mor.benefit_1.head']}</h4>
                            </div>
                            <span className="benefits-list-description">{translations['ipmob.business_model.eg_mor.benefit_1.desc']}</span>
                        </div>
                        <div className="benefits-list-item">
                            <div className="benefits-list-heading">
                                <SVGIcon className="benefit-icon" markup={creditCardIcon}/>
                                <h4 className="benefits-list-heading-text">{translations['ipmob.business_model.eg_mor.benefit_2.head']}</h4>
                            </div>
                            <span className="benefits-list-description">{translations['ipmob.business_model.eg_mor.benefit_2.desc']}</span>
                        </div>
                        <div className="benefits-list-item">
                            <div className="benefits-list-heading">
                                <SVGIcon className="benefit-icon" markup={onekeyIcon}/>
                                <h4 className="benefits-list-heading-text">{translations['ipmob.business_model.eg_mor.benefit_3.head']}</h4>
                            </div>
                            <span className="benefits-list-description">{translations['ipmob.business_model.eg_mor.benefit_3.desc']}</span>
                        </div>
                    </div>

                    <RadioButton
                        className="business-model-toggle-button"
                        id="supplierMorChoice"
                        label={<div className="business-model-label">{translations['ipmob.business_model.supplier_model']}</div>}
                        value={MERCHANT_OF_RECORD.SUPPLIER}
                        onChange={handleChoiceChange}
                        size="sm"
                        checked={businessModelChoice === MERCHANT_OF_RECORD.SUPPLIER}
                        type={'radio'}
                    />
                    <span className="business-model-choice-description">{translations['ipmob.business_model.supplier_model.desc']}</span>
                </RadioGroup>
            </div>
        );
    }

    render() {
        const {
            translations,
            businessModelChoice,
            handleChoiceChange,
            enableBusinessModelContinueBtn,
            handleNextButtonClick,
            serviceError,
            handleAlertDismiss
        } = this.props;

        return (
            <div id="businessModelPage" className="business-model-page">
                {
                    (serviceError)
                        ? <div className="alert-panel">
                            <AlertBox
                                messageKey={serviceError}
                                translations={translations}
                                handleAlertDismiss={handleAlertDismiss}
                                size={'sm'}
                            />
                        </div>
                        : null
                }
                <div className="business-model-page-wrapper">
                    <div className="business-model-heading">
                        <h1>{translations['ipmob.business_model.heading']}</h1>
                    </div>
                    <div className="business-model-toggle-button-wrapper">
                        {
                            this.getBusinessModelChoices(translations, handleChoiceChange, businessModelChoice)
                        }
                    </div>
                </div>
                <div className="business-model-page-buttons">
                    <ButtonPrimary
                        className="business-model-page-next"
                        label={translations['ipmob.button.text_2']}
                        type="submit"
                        value="Submit"
                        id={'Continue'}
                        onClick={event => handleNextButtonClick(event)}
                        disabled={!enableBusinessModelContinueBtn}
                    />
                </div>
                <img className="business-model-page-img" src={backgroundImage()}/>
            </div>
        );
    }
}

export default BusinessModel;
